import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Paper,
  Radio,
  Rating,
  Select,
  SvgIcon,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  colorDisableGrey,
  colorLinkGrey,
  colorPrimary,
  colorSecondary,
  colorTextBlack,
  colorTextGrey
} from '../config/theme';
import {
  assignForm,
  checkFormSubmitted,
  fetchFormResponseCountById,
  getFormAndFlowIds,
  getFormAndFlowIdsfeedback,
  previewFormById,
  revertFeedbackFormData,
  submitFormResponse
} from '../redux/reducers/flowsSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  base64ToFile,
  base64ToTxtCSV,
  base64URLToFile,
  handleError,
  isArrayNotEmpty
} from '../utils/utils';
import _ from 'lodash';
import {
  extensionToMimeType,
  FLOWS_FORMS_QUESTION_TYPE_SELECTOR,
  formsFileType,
  formsFileTypeIcon
} from '../utils/constant';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { ChevronRightIcon } from '../utils/iconSvg';
import { LimitOptions } from '../containers/teacherEvaluation/AddEditForm';
import { East, TroubleshootSharp } from '@mui/icons-material';
import Checkbox from '@mui/material/Checkbox';
import dayjs from 'dayjs';
import SnackBarBox from '../components/SnackBarBox';
import { getAllIndicators } from '../redux/reducers/rubricSlice';

function GiveFeedback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalResponse, setTotalResponse] = useState({ responses: 0 });
  const [flowId, setFlowId] = useState(0);
  const [formId, setFormId] = useState(0);
  const [formLayout, setFormLayout] = useState({
    flowId: formId,
    isDraft: 0,
    isDirty: false,
    formName: '',
    formText: '',
    formDescription: '',
    isActive: 1,
    questionImage1Desc: '',
    questionImage1: '',
    questionImage2Desc: '',
    questionImage2: '',
    questionImage3Desc: '',
    questionImage3: '',
    questionImage4Desc: '',
    questionImage4: '',
    questionImage5Desc: '',
    questionImage5: '',
    questionVideo1Desc: '',
    questionVideo1: '',
    questionVideo2Desc: '',
    questionVideo2: '',
    questionVideo3Desc: '',
    questionVideo3: '',
    questionVideo4Desc: '',
    questionVideo4: '',
    questionVideo5Desc: '',
    questionVideo5: '',
    questionFile1Desc: '',
    questionFile1: '',
    questionFile2Desc: '',
    questionFile2: '',
    questionFile3Desc: '',
    questionFile3: '',
    questionFile4Desc: '',
    questionFile4: '',
    questionFile5Desc: '',
    questionFile5: '',
    questionLink1: '',
    questionLink1Desc: '',
    questionLink2: '',
    questionLink2Desc: '',
    questionLink3: '',
    questionLink3Desc: '',
    questionLink4: '',
    questionLink4Desc: '',
    questionLink5: '',
    questionLink5Desc: '',
    loggedInUserName: '',
    sectionRequestList: []
  });
  const [listOfAttachments, setListOfAttachments] = useState([]);
  const [formIsValid, setFormIsValid] = useState(false);

  const { authData } = useSelector(state => state.auth);

  const { indicatorsList } = useSelector(state => state.rubric);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'error'
  });

  const {
    isFormAndFlowIdsLoading,
    isFormAndFlowIdsFailed,
    formAndFlowIdsErrorContainer,
    isFormAndFlowIdsSuccess,
    formAndFlowIds,
    isAssignFormLoading,
    isAssignFormSuccess,
    isPreviewFormSuccess,
    previewForm,
    submitFormResponseErrorContainer,
    submitResponse,
    isSubmitFormResponseSuccess,
    isSubmitFormResponseLoading,
    isSubmitFormResponseFail,
    formAndFlowIdsFeedback,
    checkFormSubmitedResponse
  } = useSelector(state => state.flow);

  useEffect(() => {
    dispatch(getAllIndicators());
    dispatch(revertFeedbackFormData());
    dispatch(getFormAndFlowIdsfeedback());
    // dispatch(checkFormSubmitted());
  }, []);

  useEffect(() => {
    if (formAndFlowIdsFeedback?.formId && formAndFlowIdsFeedback?.flowId) {
      dispatch(
        checkFormSubmitted({
          formId: formAndFlowIdsFeedback.formId,
          flowId: formAndFlowIdsFeedback?.flowId
        })
      );
    }
  }, [formAndFlowIdsFeedback]);

  useEffect(() => {
    if (!isFormAndFlowIdsLoading && isFormAndFlowIdsSuccess) {
      const { formId, flowId } = formAndFlowIds;
      setFormId(formId);
      setFlowId(flowId);

      if (formId && flowId) {
        const assignFormPayload = {
          userIds: [authData.userId],
          userGroupIds: [],
          deletedUserIds: [],
          deletedUserGroupIds: [],
          loggedInUserName: authData.userName,
          formId: formId,
          flowId: flowId
        };
        dispatch(assignForm(assignFormPayload));
      }
    }
  }, [isFormAndFlowIdsSuccess, formAndFlowIds]);

  useEffect(() => {
    if (!isAssignFormLoading && isAssignFormSuccess) {
      // const { formId, flowId } = formAndFlowIds;

      dispatch(previewFormById(formId));
    }
  }, [isAssignFormLoading, isAssignFormSuccess]);

  useEffect(() => {
    if (!isSubmitFormResponseLoading && isSubmitFormResponseSuccess) {
      setTimeout(() => {
        dispatch(revertFeedbackFormData());
      }, 2000);
    }
  }, [isSubmitFormResponseSuccess]);

  useEffect(() => {
    if (snackbar.open) {
      const timer = setTimeout(() => {
        setSnackbar({ ...snackbar, open: false });
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [snackbar]);

  useEffect(() => {
    if (isPreviewFormSuccess && previewForm) {
      let tempSectionList = [];
      let tempListOfAttachment = [];
      let previewAttachmentObject = {};

      for (let i = 1; i <= 5; i++) {
        const questionImageKey = `questionImage${i}`;
        const questionVideoKey = `questionVideo${i}`;
        const questionFileKey = `questionFile${i}`;
        const questionLinkKey = `questionLink${i}`;

        if (previewForm?.[questionImageKey]) {
          // previewAttachmentObject[questionImageKey] =
          //   previewForm?.[questionImageKey];
          previewAttachmentObject[questionImageKey] = base64ToFile(
            previewForm?.[questionImageKey],
            `${questionImageKey}Desc`
          );
        }

        if (previewForm?.[questionVideoKey]) {
          previewAttachmentObject[questionVideoKey] = base64ToFile(
            previewForm?.[questionVideoKey],
            `${questionVideoKey}Desc`
          );
        }

        if (previewForm?.[questionFileKey]) {
          previewAttachmentObject[questionFileKey] = base64ToTxtCSV(
            previewForm?.[questionFileKey],
            `${questionFileKey}Desc`
          );
        }

        if (previewForm?.[questionLinkKey]) {
          previewAttachmentObject[questionLinkKey] =
            previewForm?.[`${questionLinkKey}`];
        }
      }

      for (const [key, value] of Object.entries(previewAttachmentObject)) {
        const item = {
          title: previewForm[`${key}Desc`],
          // link: key.includes('questionLink1') ? value : null,
          link: _.includes(
            [
              'questionLink1',
              'questionLink2',
              'questionLink3',
              'questionLink4',
              'questionLink5'
            ],
            key
          )
            ? value
            : null,
          attachment: !_.includes(
            [
              'questionLink1',
              'questionLink2',
              'questionLink3',
              'questionLink4',
              'questionLink5'
            ],
            key
          )
            ? value
            : null,
          thumbnail: null,
          type: !_.includes(
            [
              'questionLink1',
              'questionLink2',
              'questionLink3',
              'questionLink4',
              'questionLink5'
            ],
            key
          )
            ? formsFileType[value.type]
            : 'link'
        };
        tempListOfAttachment.push(item);
      }

      if (isArrayNotEmpty(previewForm.sections)) {
        previewForm.sections.map((section, secIdx) => {
          let tempQuestionList = [];
          if (isArrayNotEmpty(section.questions)) {
            section.questions.map((questionList, questIdx) => {
              let linearOptions = {
                lowerLimit: questionList.lowerLimit,
                lowerLimitLabel: questionList.lowerLimitLabel,
                upperLimitLabel: questionList.upperLimitLabel,
                upperLimit: questionList.upperLimit,
                linerQuestionOptionList: questionList.linerQuestionOptionList
              };

              let tempQuestAttachment = [];
              if (
                questionList?.attachmentUrls &&
                isArrayNotEmpty(questionList?.attachmentUrls)
              ) {
                let array = questionList?.attachmentUrls;
                for (let index = 0; index < array.length; index++) {
                  const element = array[index];
                  if (element?.type != 'link') {
                    let fileName = element?.fileName?.split('.').pop();

                    let attachFile = base64URLToFile(
                      element.questionAttachmentUrl,
                      element?.fileName,
                      extensionToMimeType[fileName?.toLowerCase()]
                    );

                    tempQuestAttachment.push({
                      title: element?.fileName,
                      attachment: attachFile,
                      type: formsFileType[fileName?.toLowerCase()],
                      thumbnail: '',
                      link: ''
                    });
                  }
                }
              }

              return tempQuestionList.push({
                questionId: questionList.questionId,
                questionText: questionList.questionText,
                questionDescription: questionList.questionDescription,
                questionOptionId: questionList.questionOptionId,
                isRequired: questionList.isRequired ? 1 : 0,
                // optionTexts: questionList.questionOptions
                //   ? isArrayNotEmpty(questionList.questionOptions)
                //     ? questionList.questionOptions.map(cc => cc.optionText)
                //     : []
                //   : [],
                // optionIds: questionList.questionOptions
                //   ? isArrayNotEmpty(questionList.questionOptions)
                //     ? questionList.questionOptions.map(cc => cc.optionMappingId)
                //     : []
                //   : [],
                options: questionList.questionOptions || [],
                indicatorIds: questionList.indicators
                  ? isArrayNotEmpty(questionList.indicators)
                    ? questionList.indicators.map(cc => cc.indicatorId)
                    : []
                  : [],
                questionAttachments: [...tempQuestAttachment],
                ...linearOptions
              });
            });
          }

          tempSectionList.push({
            sectionName: section.sectionName,
            sectionDescription: section.sectionDescription,
            sectionOrder: section.sectionOrder,
            questionRequestList: tempQuestionList
          });
        });
        // setLoading(false);
        // setSelectedSection(0);
      }

      setFormLayout({
        ...formLayout,
        flowId: location.state && location.state?.flowId,
        isDraft: previewForm.isDraft ? 1 : 0,
        formName: previewForm.formName,
        formText: previewForm.formText,
        formDescription: previewForm.formDescription,
        isActive: previewForm.status ? 1 : 0,
        questionImage1Desc: previewForm.questionImage1Desc,
        questionImage1: previewForm.questionImage1,
        questionImage2Desc: previewForm.questionImage2Desc,
        questionImage2: previewForm.questionImage2,
        questionImage3Desc: previewForm.questionImage3Desc,
        questionImage3: previewForm.questionImage3,
        questionImage4Desc: previewForm.questionImage4Desc,
        questionImage4: previewForm.questionImage4,
        questionImage5Desc: previewForm.questionImage5Desc,
        questionImage5: previewForm.questionImage5,
        questionVideo1Desc: previewForm.questionVideo1Desc,
        questionVideo1: previewForm.questionVideo1,
        questionVideo2Desc: previewForm.questionVideo2Desc,
        questionVideo2: previewForm.questionVideo2,
        questionVideo3Desc: previewForm.questionVideo3Desc,
        questionVideo3: previewForm.questionVideo3,
        questionVideo4Desc: previewForm.questionVideo4Desc,
        questionVideo4: previewForm.questionVideo4,
        questionVideo5Desc: previewForm.questionVideo5Desc,
        questionVideo5: previewForm.questionVideo5,
        questionFile1Desc: previewForm.questionFile1Desc,
        questionFile1: previewForm.questionFile1,
        questionFile2Desc: previewForm.questionFile2Desc,
        questionFile2: previewForm.questionFile2,
        questionFile3Desc: previewForm.questionFile3Desc,
        questionFile3: previewForm.questionFile3,
        questionFile4Desc: previewForm.questionFile4Desc,
        questionFile4: previewForm.questionFile4,
        questionFile5Desc: previewForm.questionFile5Desc,
        questionFile5: previewForm.questionFile5,
        questionLink1: previewForm.questionLink1,
        questionLink1Desc: previewForm.questionLink1Desc,
        questionLink2: previewForm.questionLink2,
        questionLink2Desc: previewForm.questionLink2Desc,
        questionLink3: previewForm.questionLink3,
        questionLink3Desc: previewForm.questionLink3Desc,
        questionLink4: previewForm.questionLink4,
        questionLink4Desc: previewForm.questionLink4Desc,
        questionLink5: previewForm.questionLink5,
        questionLink5Desc: previewForm.questionLink5Desc,
        sectionRequestList: tempSectionList
      });
      setListOfAttachments([...tempListOfAttachment]);
    }
  }, [isPreviewFormSuccess]);

  const handleGiveFeedback = () => {
    if (checkFormSubmitedResponse) {
      setSnackbar({
        open: true,
        message: 'Feedback has already been sent.',
        type: 'error'
      });
    } else {
      dispatch(getFormAndFlowIds());
    }
  };

  const handleFormSubmit = () => {
    // const submitFormPayload = {
    //   flowId: flowId,
    //   formId: formId,
    //   userId: authData.userId,
    //   formQuestionRequestList:
    //     formLayout?.sectionRequestList[0]?.questionRequestList.flatMap(
    //       entry => {
    //         const formattedIndicatorRating = entry?.indicatorRating
    //           ? `{[${Object.entries(entry.indicatorRating)
    //               .map(([k, v]) => `{${k},${Number(v).toFixed(1)}}`)
    //               .join(',')}]}`
    //           : null;

    //         if (
    //           entry?.questionOptionId === 2 &&
    //           Array.isArray(entry?.optionMappingId).length > 0
    //         ) {
    //           // If questionOptionId is 2 and optionMappingId is an array, create separate objects
    //           return entry.optionMappingId.map(optionId => ({
    //             questionId: entry?.questionId,
    //             questionOptionId: entry?.questionOptionId,
    //             optionMappingId: optionId,
    //             responseValue: null,
    //             startResponseDate: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS'),
    //             indicatorRating: null,
    //             linearScaleMappingId: entry?.linearScaleMappingId || null
    //           }));
    //         } else {
    //           // Return object as is for other cases
    //           return {
    //             questionId: entry?.questionId,
    //             questionOptionId: entry?.questionOptionId,
    //             optionMappingId: entry?.optionMappingId || null,
    //             responseValue: entry?.responseValue || null,
    //             startResponseDate: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS'),
    //             indicatorRating: formattedIndicatorRating,
    //             linearScaleMappingId: entry?.linearScaleMappingId || null
    //           };
    //         }
    //       }
    //     )
    // };

    const submitFormPayload = {
      flowId: flowId,
      formId: formId,
      userId: authData.userId,
      isFeedbackFlag: true,
      formQuestionRequestList:
        formLayout?.sectionRequestList[0]?.questionRequestList.flatMap(
          entry => {
            const currentDate = dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS');

            const isEmpty = val =>
              val === null ||
              val === undefined ||
              val === '' ||
              (Array.isArray(val) && val.length === 0) ||
              (typeof val === 'object' && Object.keys(val).length === 0);

            if (
              (entry?.questionOptionId === 1 ||
                entry?.questionOptionId === 3) &&
              !isEmpty(entry.optionMappingId)
            ) {
              return [
                {
                  questionId: entry.questionId,
                  questionOptionId: entry.questionOptionId,
                  optionMappingId: entry.optionMappingId,
                  responseValue: null,
                  indicatorRating: null,
                  startResponseDate: currentDate,
                  linearScaleMappingId: entry.linearScaleMappingId || null
                }
              ];
            } else if (
              entry?.questionOptionId === 2 &&
              Array.isArray(entry.optionMappingId) &&
              entry.optionMappingId.length > 0
            ) {
              return entry.optionMappingId.map(optionId => ({
                questionId: entry.questionId,
                questionOptionId: entry.questionOptionId,
                optionMappingId: optionId,
                responseValue: null,
                indicatorRating: null,
                startResponseDate: currentDate,
                linearScaleMappingId: entry.linearScaleMappingId || null
              }));
            } else if (entry?.questionOptionId === 4) {
              const hasComment = !isEmpty(entry.responseValue);
              const ratingObj = entry.indicatorRating || {};
              const hasRating = Object.keys(ratingObj).length > 0;

              if (!hasComment && !hasRating) return [];

              const indicatorRatingString = hasRating
                ? `{[${Object.entries(ratingObj)
                    .map(([k, v]) => `{${k},${Number(v).toFixed(1)}}`)
                    .join(',')}]}`
                : null;

              return [
                {
                  questionId: entry.questionId,
                  questionOptionId: entry.questionOptionId,
                  optionMappingId: null,
                  responseValue: entry.responseValue || null,
                  indicatorRating: indicatorRatingString,
                  startResponseDate: currentDate,
                  linearScaleMappingId: entry.linearScaleMappingId || null
                }
              ];
            } else if (
              [5, 6, 7, 8].includes(entry.questionOptionId) &&
              !isEmpty(entry.responseValue)
            ) {
              return [
                {
                  questionId: entry.questionId,
                  questionOptionId: entry.questionOptionId,
                  optionMappingId: null,
                  responseValue: entry.responseValue || null,
                  indicatorRating: null,
                  startResponseDate: currentDate,
                  linearScaleMappingId: entry.linearScaleMappingId || null
                }
              ];
            } else {
              return []; // Skip unknown types
            }
          }
        )
    };

    dispatch(submitFormResponse(submitFormPayload));
  };

  const handleOnChange = (
    e,
    questionObj,
    optionMappingId = null,
    indicatorId = null
  ) => {
    let tempQuestionAnswer = formLayout.sectionRequestList[0]
      .questionRequestList
      ? [...formLayout.sectionRequestList[0].questionRequestList]
      : [];

    // Update the specific question's response value
    let result;

    if (
      questionObj.questionOptionId === 4 ||
      questionObj.questionOptionId === 5
    ) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          if (e?.target) {
            return {
              ...item,
              responseValue: e.target.value // Text input
            };
          }
          return {
            ...item,
            indicatorRating: {
              ...(item.indicatorRating || {}),
              [indicatorId]: e // Rating input
            }
          };
        }
        return item;
      });
    } else if (questionObj.questionOptionId === 3) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          return { ...item, optionMappingId: optionMappingId };
        }
        return item;
      });
    } else if (questionObj.questionOptionId === 6) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          return {
            ...item,
            responseValue: e ? dayjs(e).format('DD/MM/YYYY') : null
          };
        }
        return item;
      });
    } else if (questionObj.questionOptionId === 7) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          return {
            ...item,
            responseValue: e ? dayjs(e).format('hh.mm A') : null
          };
        }
        return item;
      });
    } else if (questionObj.questionOptionId === 1) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          return { ...item, optionMappingId: e.target.value || null };
        }
        return item;
      });
    } else if (questionObj.questionOptionId === 2) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          const currentOptionMappingId = item.optionMappingId || [];
          const updatedOptionMappingId = currentOptionMappingId.includes(
            optionMappingId
          )
            ? currentOptionMappingId.filter(optId => optId !== optionMappingId)
            : [...currentOptionMappingId, optionMappingId];

          return { ...item, optionMappingId: updatedOptionMappingId };
        }
        return item;
      });
    } else if (questionObj.questionOptionId === 8) {
      result = tempQuestionAnswer.map(item => {
        if (item.questionOptionId === questionObj.questionOptionId) {
          let tempLinearScaleMappingId =
            questionObj?.linerQuestionOptionList?.find(
              option => option?.numberLimit === e.target.value
            );
          return {
            ...item,
            responseValue: e.target.value,
            linearScaleMappingId: tempLinearScaleMappingId?.linerMappingId || 0
          };
        }
        return item;
      });
    }

    // Calculate form validity directly based on updated result
    const isValidResponse = questionObj => {
      if (!questionObj.isRequired) return true;

      const value = questionObj.responseValue || questionObj.optionMappingId;

      if (
        questionObj.questionOptionId === 4 ||
        questionObj.questionOptionId === 5
      ) {
        return !!value?.trim();
      }

      if (questionObj.questionOptionId === 1) {
        return value !== '' && value !== undefined && value !== null;
      }

      if (questionObj.questionOptionId === 2) {
        return Array.isArray(value) && value.length > 0;
      }

      if (questionObj.questionOptionId === 3) {
        return !!value;
      }

      if (
        questionObj.questionOptionId === 6 ||
        questionObj.questionOptionId === 7
      ) {
        return !!value;
      }

      if (questionObj.questionOptionId === 8) {
        return value !== null && value !== undefined;
      }

      return true;
    };

    const allValid = result.every(isValidResponse);

    // Update both states simultaneously
    setFormLayout({
      ...formLayout,
      sectionRequestList: [
        {
          ...formLayout.sectionRequestList[0],
          questionRequestList: result
        }
      ]
    });

    setFormIsValid(allValid); // This will immediately reflect validity
  };

  return (
    <>
      <Grid
        // display={'flex'}
        // justifyContent={'space-between'}
        alignItems={'center'}
        mb={1}
      >
        <Typography fontSize={32} fontWeight="700" display={'flex'} mb={1}>
          Feedback
        </Typography>

        <Grid
          container
          display={'flex'}
          flexDirection={'column'}
          elevation={0}
          component={Paper}
          borderRadius={'8px'}
          sx={{ padding: '14px' }}
        >
          <Typography fontSize={24} fontWeight="700" mb={1}>
            Share Your Thoughts!
          </Typography>
          {isPreviewFormSuccess ? (
            <Typography
              fontSize={14}
              fontWeight="500"
              color={colorLinkGrey}
              mb={2}
            >
              {`Share your thoughts with us. We appreciate your input!`}
            </Typography>
          ) : (
            <Typography
              fontSize={14}
              fontWeight="500"
              color={colorLinkGrey}
              mb={2}
            >
              {`Click the "Give Feedback" button to share your thoughts with us. We
            appreciate your input!`}
            </Typography>
          )}
          {!isPreviewFormSuccess && (
            <Button
              variant="contained"
              sx={{ height: '42px', width: '156px' }}
              onClick={handleGiveFeedback}
            >
              Give Feedback
            </Button>
          )}
        </Grid>
      </Grid>
      {isPreviewFormSuccess && (
        <>
          <Grid
            container
            display={'flex'}
            flexDirection={'column'}
            elevation={0}
            component={Paper}
            borderRadius={'8px'}
            sx={{ padding: '10px', borderTop: `5px solid ${colorPrimary}` }}
            marginY={2}
          >
            {formLayout.sectionRequestList
              .sort((a, b) => a.sectionOrder - b.sectionOrder)
              .map((section, sectionKey) => {
                return (
                  <Box key={sectionKey} margin={'4px 6px'}>
                    <Box
                      bgcolor={'white'}
                      padding={0.5}
                      borderRadius={2}
                      // marginBottom={2}
                    >
                      {/* <Grid container spacing={3}>
                          <Grid item sm={12}> */}
                      <Box
                        display={'flex'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        marginBottom={'8px'}
                      >
                        <SvgIcon
                          sx={{ height: 24, width: 24, marginRight: '10px' }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z"
                              stroke="#1F2933"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                        <Typography fontWeight={700} fontSize={'20px'}>
                          {section.sectionName}
                        </Typography>
                      </Box>
                      <Divider sx={{ color: '#E4E7EB' }} />

                      <TextField
                        sx={{ marginTop: 2 }}
                        name="sectionDescription"
                        fullWidth
                        placeholder="Section description (optional)"
                        size="small"
                        variant="standard"
                        readOnly
                        inputProps={{
                          maxLength: 200,
                          readOnly: true
                        }}
                        value={section.sectionDescription}
                      />
                      {/* </Grid>
                        </Grid> */}
                    </Box>
                  </Box>
                );
              })}
          </Grid>
          <Grid
            container
            display={'flex'}
            flexDirection={'column'}
            elevation={0}
            component={Paper}
            borderRadius={'8px'}
            sx={{ padding: '10px' }}
            marginY={2}
          >
            {formLayout.sectionRequestList
              .sort((a, b) => a.sectionOrder - b.sectionOrder)
              .map((section, sectionKey) => {
                return (
                  <Box key={sectionKey} margin={'4px 6px'}>
                    {section?.questionRequestList?.map((questionObj, key) => {
                      console.log(questionObj, 'questionObj');
                      let questionType =
                        FLOWS_FORMS_QUESTION_TYPE_SELECTOR.find(
                          qtyp => qtyp.id === questionObj.questionOptionId
                        );

                      let tempCheckBoxAnswers =
                        questionObj.optionMappingId || [];
                      let options = LimitOptions();

                      return (
                        <Box
                          key={key}
                          bgcolor={'white'}
                          padding={0.5}
                          borderRadius={2}
                          marginBottom={2}
                        >
                          <Grid
                            container
                            justifyContent={'space-between'}
                            alignItems={'end'}
                          >
                            <Grid item lg={6} md={12}>
                              <TextField
                                name="question"
                                fullWidth
                                sx={{
                                  '& .MuiInputBase-input': {
                                    color: colorTextBlack,
                                    fontWeight: '600',
                                    fontSize: '16px',
                                    lineHeight: '20px'
                                  }
                                }}
                                value={`${questionObj.questionText} ${questionObj.isRequired ? '*' : ''}`}
                                placeholder="Write your question here"
                                size="small"
                                variant="standard"
                                inputProps={{ maxLength: 200 }}
                                InputProps={{
                                  readOnly: true,
                                  startAdornment: (
                                    <span
                                      style={{
                                        padding: '0.5rem',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        fontWeight: 600
                                      }}
                                    >
                                      {key + 1}{' '}
                                      <East
                                        fontSize="small"
                                        sx={{
                                          marginLeft: '4px'
                                        }}
                                      />
                                    </span>
                                  )
                                }}
                              />
                              <TextField
                                name="description"
                                fullWidth
                                placeholder="Description (optional)"
                                size="small"
                                value={questionObj.questionDescription}
                                variant="standard"
                                sx={{ marginTop: 2 }}
                                inputProps={{
                                  readOnly: true,
                                  maxLength: 200,
                                  color: 'gray'
                                }}
                              />
                            </Grid>

                            <Grid item lg={12}>
                              {(questionType.id === 4 ||
                                questionType.id === 5) && (
                                <>
                                  <TextField
                                    placeholder={`${
                                      questionType.id === 4
                                        ? 'Short answer'
                                        : questionType.id === 5
                                          ? 'Long answer'
                                          : ''
                                    }`}
                                    size="small"
                                    // disabled
                                    variant="standard"
                                    onChange={e =>
                                      handleOnChange(e, questionObj)
                                    }
                                    sx={{ marginTop: 2 }}
                                    InputProps={
                                      {
                                        // readOnly: true
                                      }
                                    }
                                  />
                                </>
                              )}
                              {questionType.id === 1 && (
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  style={{
                                    width: '274px',
                                    height: '42px',
                                    marginTop: '12px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <Select
                                    value={questionObj?.optionMappingId || ''}
                                    onChange={e =>
                                      handleOnChange(e, questionObj)
                                    }
                                    displayEmpty
                                    style={{
                                      border: `1px solid ${colorTextGrey}`,
                                      outline: 'none'
                                    }}
                                    renderValue={selected => {
                                      const selectedOption =
                                        questionObj.options?.find(
                                          item =>
                                            item.optionMappingId === selected
                                        );
                                      return (
                                        <Typography
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: selectedOption
                                              ? 'black'
                                              : '#ABB4BD'
                                          }}
                                        >
                                          {selectedOption
                                            ? selectedOption.optionText
                                            : 'Select option'}
                                        </Typography>
                                      );
                                    }}
                                  >
                                    {questionObj.options?.map(item => (
                                      <MenuItem
                                        key={item.optionMappingId}
                                        value={item.optionMappingId}
                                        sx={{
                                          '&:hover': {
                                            backgroundColor: colorSecondary,
                                            cursor: 'pointer'
                                          }
                                        }}
                                      >
                                        {item.optionText}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              )}

                              {_.includes([2, 3], questionType.id) && (
                                <div style={{ position: 'relative' }}>
                                  <div>
                                    <div>
                                      {questionType.id === 2 ||
                                      questionType.id === 3
                                        ? isArrayNotEmpty(
                                            questionObj.options
                                          ) &&
                                          questionObj.options.map(
                                            (option, optionIdx) => {
                                              let optionIds =
                                                questionObj.options.map(
                                                  item => item.optionMappingId
                                                );

                                              return (
                                                <div
                                                  key={optionIdx}
                                                  style={{
                                                    padding: '8px 16px',
                                                    width: '207px',
                                                    height: '34px',
                                                    display: 'flex',
                                                    border: `1px solid ${colorDisableGrey}`,
                                                    borderRadius: '8px',
                                                    alignItems: 'center',
                                                    marginTop: '8px',
                                                    justifyContent:
                                                      'space-between',
                                                    // pointerEvents: 'none',
                                                    cursor: 'pointer'
                                                  }}
                                                  onClick={e =>
                                                    handleOnChange(
                                                      e,
                                                      questionObj,
                                                      option.optionMappingId
                                                    )
                                                  }
                                                >
                                                  <div
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      pointerEvents: 'none'
                                                    }}
                                                  >
                                                    {questionType.id === 3 ? (
                                                      <Radio
                                                        checked={
                                                          questionObj.optionMappingId ==
                                                          option.optionMappingId
                                                            ? true
                                                            : false
                                                        }
                                                        size="small"
                                                      />
                                                    ) : questionType.id ===
                                                      2 ? (
                                                      <Checkbox
                                                        checked={
                                                          tempCheckBoxAnswers.includes(
                                                            option.optionMappingId
                                                          )
                                                            ? true
                                                            : false
                                                        }
                                                        inputProps={{
                                                          'aria-label':
                                                            'controlled'
                                                        }}
                                                      />
                                                    ) : null}
                                                    <Typography
                                                      sx={{
                                                        color: colorLinkGrey,
                                                        fontWeight: 500,
                                                        fontSize: '14px'
                                                      }}
                                                    >
                                                      {option.optionText}
                                                    </Typography>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              )}

                              {questionType.id === 6 && (
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    // disabled
                                    format="DD/MM/YYYY"
                                    sx={{ marginTop: 2 }}
                                    slotProps={{
                                      textField: {
                                        size: 'small',
                                        variant: 'standard',
                                        placeholder: 'Day/Month/Year',
                                        InputProps: {
                                          sx: { color: colorTextBlack }
                                        }
                                      }
                                    }}
                                    onChange={date =>
                                      handleOnChange(date, questionObj)
                                    }
                                    components={{
                                      OpenPickerIcon: props => (
                                        <IconButton size="small" {...props}>
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M14 6.66634H2M10.6667 1.33301V3.99967M5.33333 1.33301V3.99967M5.2 14.6663H10.8C11.9201 14.6663 12.4802 14.6663 12.908 14.4484C13.2843 14.2566 13.5903 13.9506 13.782 13.5743C14 13.1465 14 12.5864 14 11.4663V5.86634C14 4.74624 14 4.18618 13.782 3.75836C13.5903 3.38204 13.2843 3.07607 12.908 2.88433C12.4802 2.66634 11.9201 2.66634 10.8 2.66634H5.2C4.0799 2.66634 3.51984 2.66634 3.09202 2.88433C2.71569 3.07607 2.40973 3.38204 2.21799 3.75836C2 4.18618 2 4.74624 2 5.86634V11.4663C2 12.5864 2 13.1465 2.21799 13.5743C2.40973 13.9506 2.71569 14.2566 3.09202 14.4484C3.51984 14.6663 4.0799 14.6663 5.2 14.6663Z"
                                              stroke={colorTextGrey}
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </IconButton>
                                      )
                                    }}
                                  />
                                </LocalizationProvider>
                              )}

                              {questionType.id === 7 && (
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <TimePicker
                                    // disabled
                                    sx={{ marginTop: 2 }}
                                    slotProps={{
                                      textField: {
                                        size: 'small',
                                        variant: 'standard',
                                        placeholder: 'Time'
                                      }
                                    }}
                                    onChange={newValue => {
                                      handleOnChange(newValue, questionObj);
                                    }}
                                    components={{
                                      OpenPickerIcon: props => (
                                        <IconButton size="small" {...props}>
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clipPath="url(#clip0_5467_42319)">
                                              <path
                                                d="M7.99967 3.99967V7.99967L10.6663 9.33301M14.6663 7.99967C14.6663 11.6816 11.6816 14.6663 7.99967 14.6663C4.31778 14.6663 1.33301 11.6816 1.33301 7.99967C1.33301 4.31778 4.31778 1.33301 7.99967 1.33301C11.6816 1.33301 14.6663 4.31778 14.6663 7.99967Z"
                                                stroke={colorTextGrey}
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_5467_42319">
                                                <rect
                                                  width="16"
                                                  height="16"
                                                  fill="white"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </IconButton>
                                      )
                                    }}
                                  />
                                </LocalizationProvider>
                              )}

                              {questionType.id === 8 && (
                                <Grid
                                  container
                                  alignItems="center"
                                  gap={4}
                                  sx={{ marginTop: 2 }}
                                >
                                  <Grid item>
                                    <Typography
                                      sx={{
                                        fontWeight: '600',
                                        fontSize: '14px'
                                      }}
                                    >
                                      {questionObj.lowerLimitLabel || 'Label 1'}
                                    </Typography>
                                  </Grid>

                                  <Grid item sx={{ display: 'flex', gap: 2 }}>
                                    {options
                                      .filter(
                                        ({ value }) =>
                                          value >= questionObj.lowerLimit &&
                                          value <= questionObj.upperLimit
                                      )
                                      .map(({ value, label }) => (
                                        <Grid
                                          container
                                          display={'flex'}
                                          flexDirection={'column'}
                                          gap={3}
                                          alignItems="center"
                                          key={value}
                                        >
                                          <Typography
                                            sx={{
                                              fontWeight: '600',
                                              fontSize: '14px'
                                            }}
                                          >
                                            {label}
                                          </Typography>
                                          <Radio
                                            value={value}
                                            // disabled
                                            checked={
                                              questionObj.responseValue == value
                                            }
                                            onChange={() =>
                                              handleOnChange(
                                                { target: { value } },
                                                questionObj,
                                                value
                                              )
                                            }
                                            sx={{
                                              height: '14px',
                                              width: '14px'
                                            }}
                                          />
                                        </Grid>
                                      ))}
                                  </Grid>

                                  <Grid item>
                                    <Typography
                                      sx={{
                                        fontWeight: '600',
                                        fontSize: '14px'
                                      }}
                                    >
                                      {questionObj.upperLimitLabel || 'Label 2'}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>

                            {questionObj?.indicatorIds &&
                              isArrayNotEmpty(questionObj?.indicatorIds) && (
                                <Grid item lg={12} mt={2}>
                                  <Box
                                    display={'flex'}
                                    flexDirection={'column'}
                                  >
                                    {isArrayNotEmpty(
                                      questionObj?.indicatorIds
                                    ) &&
                                      questionObj?.indicatorIds.map(
                                        (indicators, indiIdx) => {
                                          let tempIndObj = indicatorsList.find(
                                            cc => cc.indicatorId === indicators
                                          );
                                          return (
                                            <Box
                                              key={indiIdx}
                                              sx={{
                                                display: 'flex',
                                                gap: 2
                                              }}
                                            >
                                              <Typography
                                                fontWeight={'500'}
                                                fontsize={'14px'}
                                                sx={{
                                                  color: colorTextBlack
                                                }}
                                              >
                                                {`${tempIndObj?.indicatorName} :`}
                                              </Typography>
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'center'
                                                }}
                                              >
                                                <Rating
                                                  name="simple-controlled"
                                                  precision={0.5}
                                                  // readOnly
                                                  value={
                                                    questionObj
                                                      .indicatorRating?.[
                                                      indicators
                                                    ] || 0
                                                  }
                                                  onChange={
                                                    (event, newValue) =>
                                                      handleOnChange(
                                                        newValue,
                                                        questionObj,
                                                        null,
                                                        indicators
                                                      ) // Pass indicatorId here
                                                  }
                                                />
                                              </Box>
                                            </Box>
                                          );
                                        }
                                      )}
                                  </Box>
                                </Grid>
                              )}
                          </Grid>
                        </Box>
                      );
                    })}
                  </Box>
                );
              })}
          </Grid>

          <Grid
            elevation={0}
            width={'99%'}
            height={'74px'}
            borderRadius={'8px'}
            p={'16px'}
            component={Paper}
          >
            <Button
              variant="outlined"
              onClick={() => {
                dispatch(revertFeedbackFormData());
              }}
              style={{ marginRight: 24 }}
              sx={{
                borderColor: colorPrimary,
                borderRadius: '10px',
                color: colorTextBlack,
                borderWidth: '2px',
                height: '42px',
                width: '106px',
                '&:hover': {
                  borderColor: colorPrimary,
                  backgroundColor: 'transparent',
                  borderRadius: '10px',
                  borderWidth: '2px'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              sx={{
                width: '94px',
                height: '42px',
                boxShadow: 'none'
              }}
              // disabled={
              //   !formLayout.formName ||
              //   formLayout.sectionRequestList.length === 0 ||
              //   formLayout.sectionRequestList?.[0]?.questionRequestList
              //     .length === 0
              // }
              disabled={!formIsValid}
              variant="contained"
              onClick={() => {
                // handleSaveForm();
                handleFormSubmit();
              }}
            >
              Submit
            </Button>
          </Grid>
        </>
      )}
      {!isSubmitFormResponseLoading && isSubmitFormResponseFail && (
        <SnackBarBox
          type="error"
          message={handleError(submitFormResponseErrorContainer?.errorMessage)}
        />
      )}
      {!isSubmitFormResponseLoading && isSubmitFormResponseSuccess && (
        <SnackBarBox type="success" message={handleError(submitResponse)} />
      )}
      {!isFormAndFlowIdsLoading && isFormAndFlowIdsFailed && (
        <SnackBarBox
          type="error"
          message={handleError(formAndFlowIdsErrorContainer?.errorMessage)}
        />
      )}
      {snackbar.open && (
        <SnackBarBox
          type={snackbar.type}
          message={snackbar.message}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        />
      )}
    </>
  );
}

export default GiveFeedback;
